var React = require('react');

function XCombo2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48.67 32.5846L37.3428 47.637L51.104 58.0836L62.4312 43.0312L48.67 32.5846Z","fill":"#C1BEAC","key":0}),React.createElement("path",{"d":"M42.9245 1.81598L32.8743 15.1743L48.3274 26.9078L58.3775 13.5495L42.9245 1.81598Z","fill":"#C1BEAC","key":1}),React.createElement("path",{"d":"M30.1109 18.521L13.4952 5.5266L2.37567 20.7261L18.9914 33.7205L6.83462 50.4234L22.0193 62.2986L34.1761 45.5958L45.2956 30.3963L30.1109 18.521Z","fill":"#EB0045","fillOpacity":"0.5","key":2})]);
}

XCombo2.defaultProps = {"width":"66","height":"64","viewBox":"0 0 66 64","fill":"none"};

module.exports = XCombo2;

XCombo2.default = XCombo2;
